import React, { useState, useRef, useEffect } from "react";
import { useLocation, useHistory } from "react-router";
import { Link } from "react-router-dom";
import { exportComponentAsPNG } from "react-component-export-image";
import logo from "../../../images/logo.svg";
import "../../../styles/career-fair-one.css";
import career from "../../../images/career-day.svg";
import vector from "../../../images/Vector.png";
import UploadImgMain from "./UploadImg";

// Base template component that can be reused
export const BaseTemplate = React.forwardRef((props, ref) => {
  const {
    headerLogo,
    footerLogo,
    bottomText1,
    bottomText2,
    footerText,
    footerLink,
    footerLinkText,
    className = "mainExport",
    img
  } = props;

  return (
    <div ref={ref} className={className}>
      {img && <img src={img} alt="" className="imgPreview" />}
      <div className="meme-header">
        <img src={headerLogo} alt="" />
        <img src={logo} alt="" className="meme-logo" />
      </div>
      <div className="meme-footer-container">
        <div className="meme-theme text-white">
          <p className="bottom-text-I">{bottomText1}</p>
          <p className="bottom-text-II">{bottomText2}</p>
        </div>
        <p className="meme-footer-text">
          {footerText}
          <div className="vector">
            <div className="link-line"></div>
            <img src={vector} alt="" className="meme-footer-img" />
            <a href={footerLink} className="meme-footer-link">
              {footerLinkText}
            </a>
          </div>
        </p>
      </div>
    </div>
  );
});

// Career Fair specific implementation using the base template
export const MemeComponent = React.forwardRef((props, ref) => {
  return (
    <BaseTemplate
      ref={ref}
      headerLogo={career}
      bottomText1="I will be attending"
      bottomText2="#SecureTheBag"
      footerText="STERLING VIRTUAL CAREER DAY"
      footerLink="https://sterling.ng/careerfair"
      footerLinkText="sterling.ng/careerfair"
      img={props.img}
    />
  );
});

const CareerFair = (props) => {
  const history = useHistory();
  const memeRef = useRef();
  const location = useLocation();

  const [imgPreview, setImgPreview] = useState(null);
  const [modal, setModal] = useState("close");

  const uploadImgModal = () => {
    setModal("open");
  };
  const previewModal = () => {
    setModal("preview");
  };
  const closeModal = () => {
    setModal("close");
  };

  const imgChange = (e) => {
    if (e.target.files[0]) {
      const url = URL.createObjectURL(e.target.files[0]);
      setImgPreview(url);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      {modal === "open" && (
        <UploadImgMain closeModal={closeModal} previewModal={previewModal} />
      )}
      <div className="h-screen flex template-main">
        <div className="actions p-8">
          <Link to="/">
            <img src={logo} alt="logo" className="h-10 w-10 rounded-full" />
          </Link>
          <div className="btns my-10 space-y-4">
            <input
              type="file"
              className="hidden"
              onChange={imgChange}
              id="img"
            />
            <label className="upload" onClick={uploadImgModal}>
              Upload Photo
            </label>
            <button className="change-template" onClick={history.goBack}>
              Change Template
            </button>
          </div>
        </div>
        <div className="main p-4">
          <MemeComponent ref={memeRef} img={imgPreview} />
          <div
            className="memeBtns flex mt-4 w-full space-x-4 justify-between h-12"
            style={{ fontFamily: "Museo300" }}
          >
            <button
              className="w-full bg-green-500 rounded h-full font-bold text-white"
              onClick={uploadImgModal}
            >
              Select Photo
            </button>
            <button
              className="change-template w-full rounded h-full font-bold"
              onClick={history.goBack}
            >
              Change Template
            </button>
          </div>
          <button
            className="meme-download"
            onClick={() =>
              exportComponentAsPNG(memeRef, { fileName: "SecureTheBag" })
            }
          >
            Download Meme
          </button>
        </div>
      </div>
    </>
  );
};

export default CareerFair;
